<div class="scroll-to-top" [ngClass]="{'show-scrollTop': windowScrolled}">
  <button-item
    [back]="'white'"
    [icon]="['fa-solid','fa-angle-up']"
    [tooltip]="'Voltar ao topo'"
    (click)="scrollToTop()"
  ></button-item>
</div>

